import {LiveRoomReportDTO, QuestionAnswersCount, QuestionReport} from '../../incase-domain/analytics';
import {
    AnalyticsReducerType,
    UPDATE_ANALYTICS_DATA,
    UPDATE_LIVE_ROOM_REPORT,
    UPDATE_QUESTION_ANSWERS_COUNT,
    UPDATE_QUESTION_REPORT,
} from '../actions/types/analytics.actions.types';

export interface AnalyticsReducerState {
    showAnalytics: boolean;
    data: [];
    questionReports: QuestionReport[];
    questionAnswersCountAll: QuestionAnswersCount[];
    liveRoomReport?: LiveRoomReportDTO;
}

export const preloadedState: AnalyticsReducerState = {
    showAnalytics: false,
    data: [],
    questionReports: [],
    questionAnswersCountAll: [],
};

export const analyticsReducer = (state: AnalyticsReducerState = preloadedState, action: AnalyticsReducerType): AnalyticsReducerState => {
    switch (action.type) {
        case UPDATE_ANALYTICS_DATA:
            return {...state, data: action.analyticsData};
        case UPDATE_QUESTION_REPORT:
            return {
                ...state,
                questionReports: state.questionReports.some((qr) => qr.elementId === action.questionReport.elementId)
                    ? state.questionReports.map((qr) => (qr.elementId === action.questionReport.elementId ? action.questionReport : qr))
                    : [...state.questionReports, action.questionReport],
            };
        case UPDATE_QUESTION_ANSWERS_COUNT:
            return {
                ...state,
                questionAnswersCountAll: state.questionAnswersCountAll.some((qr) => qr.elementId === action.questionAnswersCount.elementId)
                    ? state.questionAnswersCountAll.map((qr) =>
                          qr.elementId === action.questionAnswersCount.elementId ? action.questionAnswersCount : qr
                      )
                    : [...state.questionAnswersCountAll, action.questionAnswersCount],
            };
        case UPDATE_LIVE_ROOM_REPORT:
            return {...state, liveRoomReport: action.liveRoomReport};
        default:
            return state;
    }
};
